import React, { FC } from 'react';
import { withHeader } from '../../HOC/withHeader';
import { RecognitionPage } from '../../modules/recognition/RecognitionPage';

const Module: FC = () => <RecognitionPage type="document" />;

export const PdfToTextPageContainer: FC = withHeader(Module);
